<template>
    <div class="panel panel-default panel-dashboard">
        <div class="panel-body" :class="{'meeting-legend-limited': collapsed}">
            <dl>
                <dt>
                    Meetings
                </dt>

                <dd>
                    Meetings are filtered on the day they start. Both the number of held meetings and the
                    total number of meetings are displayed in the <i>Overview</i> and <i>By User</i> panels.
                </dd>

                <br>

                <dt>
                    Conversion Rates
                </dt>

                <dd>
                    The conversion rates for opportunities and sales are both based on the total number of meetings.
                </dd>

                <br>

                <dt>
                    Opportunities
                </dt>

                <dd>
                    In this dashboard, opportunities are counted as the number of meetings that resulted in at least
                    one opportunity. If more than one opportunity is created from a meeting, the meeting is still
                    only counted once.
                </dd>

                <br>

                <dt>
                    Sales
                </dt>

                <dd>
                    A sale is counted as a meeting that resulted in at least one advertising order or one subscription.
                    If a meeting results in both an advertising order and a subscription, or more than one of each, it
                    is still only counted once.
                </dd>

                <br>

                <dt>
                    Sales Value
                </dt>

                <dd>
                    The value of sales are calculated as the sum of the price of all ads on orders related to a meeting
                    and the sum of the price of all subscription periods related to a meeting.
                </dd>

                <br>

                <dt>
                    By Week
                </dt>

                <dd>
                    In the <i>By Week</i> chart, the held meetings columns are the meetings that did not result in any
                    opportunities created. The booked meetings columns are meetings that have not yet been held. Thus,
                    the sum of the held meetings, booked meetings, opportunities and sales columns is the total number
                    of meetings in the week.
                </dd>
            </dl>

            <div class="meeting-legend-show-more" :class="{'meeting-legend-show-more--collapsed': collapsed}">
                <button type="button" class="btn btn-xs btn-black" @click="collapsed = !collapsed">
                    <i class="fa fa-search"/> {{ collapsed ? 'Expand' : 'Collapse'}}
                </button>
            </div>
        </div>
    </div>
</template>

<style>
    .meeting-legend-limited {
        height: 200px;
        overflow: hidden;
        position: relative;
    }

    .meeting-legend-show-more {
        text-align: center;
        width: 100%;
    }

    .meeting-legend-show-more--collapsed {
        background-image: linear-gradient(to bottom, transparent, white);
        position: absolute;
        bottom: 0;
        left: 0;
        padding: 20px;
    }
</style>

<script>
    export default {
        data() {
            return {
                collapsed: true
            }
        }
    }
</script>
